module.exports = __webpack_public_path__ + "img/05c63b3.svg";